import logo from "../assets/logo.png";
import { Lang, t } from "../i18n/translations";

interface Props { lang: Lang; }

export default function HowItWorks({ lang }: Props) {
  const tr = t[lang].how;

  return (
    <section className="section how">
      <h2 className="section-title">{tr.title}</h2>
      <div className="steps">
        {tr.steps.map((step, i) => (
          <div className="step" key={i}>
            <div className="step-number">{i + 1}</div>
            <div className="step-icon">
              {step.icon === "__logo__"
                ? <img src={logo} alt="MyLittleMouse" className="step-logo" />
                : step.icon}
            </div>
            <h3>{step.title}</h3>
            <p>{step.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
